<script lang="ts">
    import type { Price } from '@shared/types/types';
    import type { UvpMode } from '@tile/components/suggested-retail-price-experiment/SuggestedRetailPriceExperiment.svelte';

    interface Props {
        price: Price;
        uvpMode?: UvpMode;
    }

    let { price, uvpMode = 'default' }: Props = $props();

    const displayPrice = $derived(`${price.isStartingPrice ? 'ab ' : ''} ${price.retailPrice} €`);
    const redPrice = $derived((uvpMode === 'default' && price.sale) || uvpMode === 'red' || uvpMode === 'strikeRed');
</script>

<span
    class={[
        'oc-headline-50',
        'reptile-price__retailPrice',
        'reptile-price__priceValue',
        redPrice && 'reptile-price__priceValue--red',
    ]}
>
    {displayPrice}
</span>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-price {
        &__retailPrice {
            margin-right: tokens.$oc-semantic-spacing-25;
        }

        &__priceValue {
            white-space: nowrap;

            &--red {
                color: tokens.$oc-semantic-color-text-sale;
            }
        }
    }
</style>
